// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-select-container {
  position: relative;
  width: 100%;
}

.search-select-container.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-select-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 14px;
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 15px;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
          user-select: none;
}

[data-theme="dark"] .search-select-trigger {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.search-select-trigger:hover:not(.disabled) {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.1);
}

.search-select-trigger.open {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.search-select-trigger.has-value {
  color: #0f172a;
}

[data-theme="dark"] .search-select-trigger.has-value {
  color: #f8fafc;
}

.search-select-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 8px;
}

.search-select-arrow {
  display: flex;
  align-items: center;
  color: #94a3b8;
  transition: transform 0.2s ease;
}

.search-select-trigger.open .search-select-arrow {
  transform: rotate(180deg);
  color: #0ea5e9;
}

.search-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 300px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 50;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

[data-theme="dark"] .search-select-dropdown {
  background-color: #1e293b;
  border-color: #334155;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2);
}

.search-select-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
}

[data-theme="dark"] .search-select-search-wrapper {
  border-bottom-color: #334155;
}

.search-select-search-wrapper .search-icon {
  position: absolute;
  left: 20px;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.search-select-input {
  width: 100%;
  padding: 8px 12px 8px 32px;
  font-size: 14px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  outline: none;
  background-color: #f8fafc;
  color: #0f172a;
  transition: all 0.2s;
}

[data-theme="dark"] .search-select-input {
  border-color: #475569;
  background-color: #0f172a;
  color: #f8fafc;
}

.search-select-input:focus {
  border-color: #0ea5e9;
  background-color: #ffffff;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.1);
}

[data-theme="dark"] .search-select-input:focus {
  background-color: #0f172a;
}

.search-select-options-list {
  flex: 1 1;
  overflow-y: auto;
  max-height: 180px;
  padding: 4px;
}

.search-select-option {
  padding: 8px 12px;
  font-size: 14px;
  color: #475569;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

[data-theme="dark"] .search-select-option {
  color: #cbd5e1;
}

.search-select-option:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

[data-theme="dark"] .search-select-option:hover {
  background-color: #334155;
  color: #f8fafc;
}

.search-select-option.selected {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: 600;
}

[data-theme="dark"] .search-select-option.selected {
  background-color: #0369a1;
  color: #e0f2fe;
}

.search-select-loading,
.search-select-no-results {
  padding: 16px;
  text-align: center;
  font-size: 14px;
  color: #64748b;
}

.search-select-create-action {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #0284c7;
  border-top: 1px solid #f1f5f9;
  text-align: center;
  cursor: pointer;
  background-color: #f8fafc;
  transition: all 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

[data-theme="dark"] .search-select-create-action {
  color: #38bdf8;
  border-top-color: #334155;
  background-color: #0f172a;
}

.search-select-create-action:hover {
  background-color: #f0f9ff;
  color: #0369a1;
}

[data-theme="dark"] .search-select-create-action:hover {
  background-color: #1e293b;
  color: #7dd3fc;
}

@keyframes slideDownFade {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =========================================
   RESPONSIVE DESIGN (Tablets y Móviles)
   ========================================= */
@media (max-width: 768px) {
  .search-select-trigger {
    padding: 14px 16px;
    font-size: 16px;
  }

  .search-select-input {
    padding: 12px 14px 12px 36px;
    font-size: 16px;
  }

  .search-select-search-wrapper .search-icon {
    left: 14px;
  }

  .search-select-option {
    padding: 14px 16px;
    font-size: 16px;
  }

  .search-select-create-action {
    padding: 14px 16px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SearchSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mFAAmF;EACnF,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;8CAE8C;AAC9C;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".search-select-container {\n  position: relative;\n  width: 100%;\n}\n\n.search-select-container.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.search-select-trigger {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 14px;\n  background-color: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n}\n\n[data-theme=\"dark\"] .search-select-trigger {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.search-select-trigger:hover:not(.disabled) {\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.1);\n}\n\n.search-select-trigger.open {\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.search-select-trigger.has-value {\n  color: #0f172a;\n}\n\n[data-theme=\"dark\"] .search-select-trigger.has-value {\n  color: #f8fafc;\n}\n\n.search-select-value {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 8px;\n}\n\n.search-select-arrow {\n  display: flex;\n  align-items: center;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n}\n\n.search-select-trigger.open .search-select-arrow {\n  transform: rotate(180deg);\n  color: #0ea5e9;\n}\n\n.search-select-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  max-height: 300px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  z-index: 50;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n[data-theme=\"dark\"] .search-select-dropdown {\n  background-color: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2);\n}\n\n.search-select-search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n[data-theme=\"dark\"] .search-select-search-wrapper {\n  border-bottom-color: #334155;\n}\n\n.search-select-search-wrapper .search-icon {\n  position: absolute;\n  left: 20px;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n}\n\n.search-select-input {\n  width: 100%;\n  padding: 8px 12px 8px 32px;\n  font-size: 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  outline: none;\n  background-color: #f8fafc;\n  color: #0f172a;\n  transition: all 0.2s;\n}\n\n[data-theme=\"dark\"] .search-select-input {\n  border-color: #475569;\n  background-color: #0f172a;\n  color: #f8fafc;\n}\n\n.search-select-input:focus {\n  border-color: #0ea5e9;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.1);\n}\n\n[data-theme=\"dark\"] .search-select-input:focus {\n  background-color: #0f172a;\n}\n\n.search-select-options-list {\n  flex: 1;\n  overflow-y: auto;\n  max-height: 180px;\n  padding: 4px;\n}\n\n.search-select-option {\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #475569;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n[data-theme=\"dark\"] .search-select-option {\n  color: #cbd5e1;\n}\n\n.search-select-option:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n[data-theme=\"dark\"] .search-select-option:hover {\n  background-color: #334155;\n  color: #f8fafc;\n}\n\n.search-select-option.selected {\n  background-color: #e0f2fe;\n  color: #0369a1;\n  font-weight: 600;\n}\n\n[data-theme=\"dark\"] .search-select-option.selected {\n  background-color: #0369a1;\n  color: #e0f2fe;\n}\n\n.search-select-loading,\n.search-select-no-results {\n  padding: 16px;\n  text-align: center;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.search-select-create-action {\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0284c7;\n  border-top: 1px solid #f1f5f9;\n  text-align: center;\n  cursor: pointer;\n  background-color: #f8fafc;\n  transition: all 0.2s;\n  user-select: none;\n}\n\n[data-theme=\"dark\"] .search-select-create-action {\n  color: #38bdf8;\n  border-top-color: #334155;\n  background-color: #0f172a;\n}\n\n.search-select-create-action:hover {\n  background-color: #f0f9ff;\n  color: #0369a1;\n}\n\n[data-theme=\"dark\"] .search-select-create-action:hover {\n  background-color: #1e293b;\n  color: #7dd3fc;\n}\n\n@keyframes slideDownFade {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* =========================================\n   RESPONSIVE DESIGN (Tablets y Móviles)\n   ========================================= */\n@media (max-width: 768px) {\n  .search-select-trigger {\n    padding: 14px 16px;\n    font-size: 16px;\n  }\n\n  .search-select-input {\n    padding: 12px 14px 12px 36px;\n    font-size: 16px;\n  }\n\n  .search-select-search-wrapper .search-icon {\n    left: 14px;\n  }\n\n  .search-select-option {\n    padding: 14px 16px;\n    font-size: 16px;\n  }\n\n  .search-select-create-action {\n    padding: 14px 16px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
